import { render, staticRenderFns } from "./PublicDashboardAccessCodePage.vue?vue&type=template&id=76bf4592"
import script from "./PublicDashboardAccessCodePage.vue?vue&type=script&lang=js"
export * from "./PublicDashboardAccessCodePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76bf4592')) {
      api.createRecord('76bf4592', component.options)
    } else {
      api.reload('76bf4592', component.options)
    }
    module.hot.accept("./PublicDashboardAccessCodePage.vue?vue&type=template&id=76bf4592", function () {
      api.rerender('76bf4592', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PublicDashboardAccessCodePage.vue"
export default component.exports